@if (showSidebar) {
  <div class="h-screen w-full bg-slate-100 lg:grid lg:grid-cols-[280px_1fr]">
    <div class="hidden h-screen bg-[#2f465a] lg:block">
      <app-component-sidebar />
    </div>

    <div class="h-screen overflow-y-auto">
      <router-outlet />
    </div>
  </div>
} @else {
  <div class="h-screen w-full">
    <router-outlet />
  </div>
}

<ng-container *ngComponentOutlet="modalHostComponent"></ng-container>
